import styled from 'styled-components';
import { Colors } from "~/config/Colors";

export const TableContainer = styled.div`

`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1em;
`;

export const ItemTable = styled.div`
  display: flex;
  gap: 1rem;
  border: 2px solid #f8f8f8;
  padding: 0.5em 1em 0.5em 1em;
  background: ${Colors.Color2};
  border-radius: 0.5em;

  .search {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    cursor: pointer;

    .icon {
      width: 2em;

      img {
        width: 100%;
      }
    }
  }

  .message {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    width: 100%;

    .header {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      width: 100%;

      .author {
        
        .identification {
          font-size: 0.9em;
          color: ${Colors.Color3};
          font-weight: 600;
        }
      }

      .information {
        display: flex;
        gap: 1em;
        margin-left: 1em;

        p {
          font-size: 0.7em;
          color: ${Colors.Color7};
          font-weight: 500;
          position: relative;

          ::before {
            content: "";
            position: absolute;
            width: 0.35em;
            height: 0.35em;
            background: ${Colors.Color7};
            left: -1em;
            top: calc(50% - 0.175em);
            border-radius: 1em;
          }
        }
      }
    }

    .list-message {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      width: fit-content;

      .content {
        width: 100%;
        padding: 1rem;
        background: ${localStorage.getItem("tema") == "C" ? Colors.Color10 : "#23202b"};
        border-radius: 0 8px 8px 8px;
        position: relative;

        /* ::before {
          background: ${localStorage.getItem("tema") == "C" ? Colors.Color10 : "#23202b"};
          content: '';
          position: absolute;
          top: 0px;
          left: -1.2em;
          width: 3em;
          height: 1em;
          border-radius: 8px;
          clip-path: polygon(50% 0%, 50% 100%, 0% 0%);
        } */

        .titulo {
          font-size: 0.65em;
          color: ${Colors.Color7};
          font-weight: 800;
        }

        .texto {
          font-size: 0.8em;
          color: ${Colors.Color3};
          font-weight: 600;
        }
      }
    }
  }
`;
